import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faStar } from '@fortawesome/free-solid-svg-icons';
import CaratulaRelacionar from '../../../../../assets/icons/SolidGreenIcons/relacionar.svg'
import CaratulaRompecabezas from '../../../../../assets/icons/SolidGreenIcons/rompecabezas.svg'
import CaratulaPreguntas from '../../../../../assets/icons/SolidGreenIcons/preguntas.svg'
import CaratulaPreguntasAbiertas from '../../../../../assets/icons/SolidGreenIcons/preguntasabiertas.svg'
import CaratulaOrdenar from '../../../../../assets/icons/SolidGreenIcons/ordenar.svg'
import CaratulaArrastrar from '../../../../../assets/icons/SolidGreenIcons/arrastrar.svg'
import CaratulaMemorama from '../../../../../assets/icons/SolidGreenIcons/memorama.svg'
import CaratulaSopa from '../../../../../assets/icons/SolidGreenIcons/sopadeletras.svg'
import CaratulaCrucigrama from '../../../../../assets/icons/SolidGreenIcons/crucigrama.svg'
import CaratulaHotspot from '../../../../../assets/icons/SolidGreenIcons/hotspot.svg'
import CaratulaPracticario from '../../../../../assets/icons/SolidGreenIcons/practicarios.svg'
import CaratulaDibujo from '../../../../../assets/icons/icons-bloques/caratulaDibujo.jpg'
import CaratulaHablar from '../../../../../assets/icons/icons-bloques/caratulaHablar.png'
import CaratulaLeer from '../../../../../assets/icons/icons-bloques/caratulaLeer.png'
import CaratulaEscuchaEscribe from '../../../../../assets/icons/icons-bloques/caratulaEscuchaEscribe.png'
import { Trans } from 'react-i18next';

// Llave de i18n del nombre de cada tipo. Antes esto era un mapa de textos en
// español y el nombre de la actividad quedaba fuera del bundle: en un libro en
// inglés la carátula decía "PREGUNTAS" con el botón en "Start!".
//
// La mayoría reusa el título del bloque; los cinco `tipo*` tienen llave propia
// porque el título completo no cabe en esta etiqueta (columna de 150px, en
// mayúsculas): "Lectura de párrafo (velocidad)" se desborda.
const TIPO_LLAVES = {
  rompecabezas: 'rompecabezasTitle',
  relacionar: 'relacionarTitle',
  preguntas: 'preguntasTitle',
  preguntasAbiertas: 'preguntasAbiertasTitle',
  arrastrar: 'arrastrarTitle',
  ordenar: 'ordenarTitle',
  memorama: 'memoramaTitle',
  sopa: 'sopaTitle',
  crucigrama: 'crucigramaTitle',
  hotspot: 'hotspotTitle',
  hotspotMultiple: 'hotspotMultipleTitle',
  encontrarDiferencias: 'encontrarTitle',
  dibujo: 'tipoDibujo',
  lecturaPalabras: 'tipoLecturaPalabras',
  lecturaPronunciacion: 'tipoLecturaPronunciacion',
  lecturaVelocidad: 'tipoLecturaVelocidad',
  leeYEscucha: 'tipoLeeYEscucha',
  escuchaEscribe: 'dictadosTitle',
  practicario: 'practicarioTitle',
}

const STYLES = `
  @keyframes pi-slide-in {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes pi-float {
    0%, 100% { transform: translateY(0); }
    50%       { transform: translateY(-6px); }
  }
  @keyframes pi-star-bounce {
    0%   { transform: scale(1); }
    35%  { transform: scale(1.45); }
    65%  { transform: scale(0.88); }
    100% { transform: scale(1); }
  }
`

function PantallaInicio({title, description, isDone, start, tipo, lang}) {
  const chooseBg =
    tipo === 'rompecabezas' ? CaratulaRompecabezas :
    tipo === 'relacionar' ? CaratulaRelacionar :
    tipo === 'preguntas' ? CaratulaPreguntas :
    tipo === 'preguntasAbiertas' ? CaratulaPreguntasAbiertas :
    tipo === 'arrastrar' ? CaratulaArrastrar :
    tipo === 'ordenar' ? CaratulaOrdenar :
    tipo === 'memorama' ? CaratulaMemorama :
    tipo === 'sopa' ? CaratulaSopa :
    tipo === 'crucigrama' ? CaratulaCrucigrama :
    tipo === 'hotspot' || tipo === 'hotspotMultiple' || tipo === 'encontrarDiferencias' ? CaratulaHotspot :
    tipo === 'dibujo' ? CaratulaDibujo :
    tipo === 'lecturaPalabras' || tipo === 'lecturaPronunciacion' || tipo === 'lecturaVelocidad' ? CaratulaHablar :
    tipo === 'leeYEscucha' ? CaratulaLeer :
    tipo === 'escuchaEscribe' ? CaratulaEscuchaEscribe :
    tipo === 'practicario' ? CaratulaPracticario :
    ''

  const hasResult = isDone && isDone.intento > 0
  const stars = hasResult
    ? isDone.puntuacionTop >= 7 ? 3 : isDone.puntuacionTop >= 4 ? 2 : 1
    : 0

  // El idioma lo resuelve el bundle, no este componente: `lang` es el idioma del
  // AUDIO de las actividades de habla (viene del JSON del bloque), no el de la
  // interfaz. Al usarlo aquí, un dictado en inglés —el valor por defecto— pintaba
  // el id interno del bloque en pantalla: "ESCUCHAESCRIBE".
  const tipoLlave = TIPO_LLAVES[tipo]
  const [hovered, setHovered] = useState(false)

  return (
    <>
      <style>{STYLES}</style>
      <div
        className="rounded-2xl overflow-hidden border border-gray-100 shadow-md"
        style={{ animation: 'pi-slide-in 0.45s ease-out both' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Rainbow top stripe */}
        <div className="h-1.5" style={{ background: 'linear-gradient(to right, #f97316, #fbbf24, #4ade80, #38bdf8, #a855f7)' }} />

        <div className="flex items-center bg-white py-10 hover:bg-[#f9f9f9] bg-[#fcfdfe]">
          {/* Left: Activity icon */}
          <div className={`flex items-center justify-center px-5 border-r border-gray-100 shrink-0 ${hasResult ? '' : 'flex-1'}`}>
            <div
              className="w-[12rem] h-[12rem] flex items-center justify-center overflow-hidden"
              style={{ animation: hovered ? 'pi-float 3.5s ease-in-out infinite' : 'none' }}
            >
              {chooseBg && <img src={chooseBg} alt="" className="w-full h-full object-cover" />}
            </div>
          </div>

          {/* Middle: Score */}
          {hasResult ?
          <div className="flex-1 px-6 flex flex-col justify-center min-h-[96px]">
            <p className="text-sm tracking-widest text-gray-400 font-semibold uppercase mb-2">
              <Trans i18nKey="tuResultado">TU RESULTADO</Trans>
            </p>
            <div className="flex gap-1 mb-1">
              {[1, 2, 3].map(i => (
                <FontAwesomeIcon
                  key={i}
                  icon={faStar}
                  className={i <= stars ? 'text-yellow-400' : 'text-gray-200'}
                  size="2x"
                  style={{ animation: hovered ? `pi-star-bounce 0.45s ease-out ${i * 0.1}s both` : 'none' }}
                />
              ))}
            </div>
            <div className="flex gap-4">
              <p className="text-4xl font-bold text-[#1e72fd]"><span className="text-base  mr-1"><Trans i18nKey="mejor">Mejor</Trans></span><span className="text-base">{isDone.puntuacionTop}</span><span className="text-base">/10</span></p>
              <p className="text-4xl font-bold text-gray-400"><span className="text-base   mr-1"><Trans i18nKey="ultimo">Último</Trans></span><span className="text-base">{isDone.puntuacionUltimoIntento}</span><span className="text-base text-gray-400">/10</span></p>
            </div>
          </div>
          :<></>
          }

          {/* Right: Type label + Start button with ripple rings */}
          <div className={`relative flex flex-col items-center justify-center px-6 py-4 shrink-0 min-w-[150px] mr-4 ${hasResult ? '' : 'flex-1'}`}>
            {/* Static concentric rings — always visible like the reference */}
            {[200, 160, 120, 84, 50].map((size, i) => (
              <div
                key={`ring-${i}`}
                className="absolute rounded-full border-[10px] border-gray-[#eceff4]"
                style={{ width: size, height: size }}
              />
            ))}
            <p className="text-sm tracking-widest text-gray-400 font-semibold uppercase mb-3 z-10">
              {tipoLlave ? <Trans i18nKey={tipoLlave}></Trans> : tipo}
            </p>
            <button
              className="relative z-10 flex items-center gap-2 bg-gradient-to-r from-[#18bafb] to-[#1a65d6] text-white font-bold text-lg px-5 py-2.5 rounded-[8px] mb-[20px] shadow-md hover:brightness-110 hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              onClick={() => start(true)}
            >
              <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faPlay} className="text-base ml-0.5" />
              </div>
              <Trans i18nKey="comenzarButton">Iniciar</Trans>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default PantallaInicio
